var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJitLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 64,
    width: 125,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "white",
    d: "m14.588,21.687l13.775,0l0,16.859c0,2.751 -0.096,2.803 -6.066,8.656l-0.68,0.67l3.713,3.979l1.219,-1.182c6.648,-6.462 7.348,-7.143 7.348,-12.489l0,-22.031l-19.309,0l0,5.538z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "white",
    d: "m94.939,27.216l0,-11.067l-5.562,0l0,27.684l5.562,0l0,-11.067l12.429,0l0,-5.55l-12.429,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "white",
    d: "m59.5,43.833l10.447,-27.684l-6.135,0l-10.456,27.684l6.144,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJitLogo);
export default __webpack_public_path__ + "static/media/jit_logo.380505e6bdd7b991128758a5210ea095.svg";
export { ForwardRef as ReactComponent };